<template>
  <div id="basic-info">
    <v-card class="card-shadow border-radius-xl mt-4">
      <v-card-title class="pb-0 d-flex align-center">
        <h6 class="mb-0 text-h6 text-typo font-weight-bold">基本資料</h6>
        <v-spacer></v-spacer>
        <template v-if="!isCreateMode">
          <template v-if="!edit">
            <v-btn icon @click="startEdit" :ripple="false">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <!-- history -->
            <!-- <v-btn icon @click="showHistory" :ripple="false">
              <v-icon>mdi-history</v-icon>
            </v-btn> -->
          </template>
          <template v-else>
            <v-btn icon class="mr-2" @click="cancelEdit" :ripple="false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-btn icon :loading="saving" @click="submit" :ripple="false">
              <v-icon color="red">mdi-content-save</v-icon>
            </v-btn>
          </template>
        </template>
      </v-card-title>
      <!-- 基本資料 -->
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >姓名</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  userData.name
                }}</v-list-item-title>
                <v-text-field
                  v-else-if="canEditRole"
                  v-model="form.name"
                  dense
                  hide-details="auto"
                ></v-text-field>
                <v-list-item-title v-else class="text-body-1 text-typo">{{
                  userData.name
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <!-- mobile_country_code -->
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >手機區碼</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  userData.mobile_country_code
                    ? userData.mobile_country_code
                    : ""
                }}</v-list-item-title>
                <v-text-field
                  v-else-if="canEditRole"
                  v-model="form.mobile_country_code"
                  dense
                  hide-details="auto"
                ></v-text-field>
                <v-list-item-title v-else class="text-body-1 text-typo">{{
                  userData.mobile_country_code
                    ? userData.mobile_country_code
                    : ""
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >手機</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  userData.mobile_phone ? userData.mobile_phone : ""
                }}</v-list-item-title>
                <v-text-field
                  v-else-if="canEditRole"
                  v-model="form.user_mobile_phone"
                  dense
                  hide-details="auto"
                ></v-text-field>
                <v-list-item-title v-else class="text-body-1 text-typo">{{
                  userData.mobile_phone ? userData.mobile_phone : ""
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <!-- password -->
          <v-col cols="12" md="3" v-if="isCreateMode">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >密碼</v-list-item-subtitle
                >
                <v-text-field
                  v-if="canEditRole"
                  v-model="form.password"
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >英文姓名</v-list-item-subtitle
                >
                <v-list-item-title
                  v-if="!edit || !canEditRole"
                  class="text-body-1 text-typo"
                  >{{ profileData.english_name || "未設定" }}</v-list-item-title
                >
                <v-text-field
                  v-else-if="canEditRole"
                  v-model="form.english_name"
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >工號</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.member_id
                }}</v-list-item-title>
                <v-text-field
                  v-else-if="canEditRole"
                  v-model="form.member_id"
                  dense
                  hide-details="auto"
                ></v-text-field>
                <v-list-item-title v-else class="text-body-1 text-typo">{{
                  profileData.member_id
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >Email</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  userData.email ? userData.email : ""
                }}</v-list-item-title>
                <v-text-field
                  v-else-if="canEditRole"
                  v-model="form.user_email"
                  dense
                  hide-details="auto"
                ></v-text-field>
                <v-list-item-title v-else class="text-body-1 text-typo">{{
                  userData.email ? userData.email : ""
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >部門</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.department
                }}</v-list-item-title>
                <v-text-field
                  v-else-if="canEditRole"
                  v-model="form.department"
                  dense
                  hide-details="auto"
                ></v-text-field>
                <v-list-item-title v-else class="text-body-1 text-typo">{{
                  profileData.department
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >店舖</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.store
                }}</v-list-item-title>
                <v-text-field
                  v-else-if="canEditRole"
                  v-model="form.store"
                  dense
                  hide-details="auto"
                ></v-text-field>
                <v-list-item-title v-else class="text-body-1 text-typo">{{
                  profileData.store
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >職位</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.job_title
                }}</v-list-item-title>
                <v-text-field
                  v-else-if="canEditRole"
                  v-model="form.job_title"
                  dense
                  hide-details="auto"
                ></v-text-field>
                <v-list-item-title v-else class="text-body-1 text-typo">{{
                  profileData.job_title
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="3" v-if="!isCreateMode">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >角色</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  roleText
                }}</v-list-item-title>
                <v-select
                  v-else-if="canEditRole"
                  v-model="form.user_role"
                  :items="EDITABLE_ROLE_MAPPING"
                  item-text="text"
                  item-value="value"
                  dense
                  hide-details="auto"
                ></v-select>
                <v-list-item-title v-else class="text-body-1 text-typo">{{
                  roleText
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="3" v-if="!isCreateMode">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >審核狀態</v-list-item-subtitle
                >
                <v-list-item-title
                  v-if="!edit || !canEditRole"
                  class="text-body-1 text-typo"
                  >{{ form.approval_status }}</v-list-item-title
                >
                <v-select
                  v-else-if="canEditRole"
                  v-model="form.approval_status"
                  :items="APPROVAL_STATUS_OPTIONS"
                  item-text="text"
                  item-value="value"
                  dense
                  hide-details="auto"
                ></v-select>
                <v-list-item-title v-else class="text-body-1 text-typo">{{
                  approvalStatusText
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider class="my-4"></v-divider>
      <v-card-title class="pb-0 d-flex align-center">
        <h6 class="mb-0 text-h6 text-typo font-weight-bold">更多資料</h6>
      </v-card-title>
      <v-card-text>
        <!-- Additional Basic Info -->
        <v-row>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >聯絡人</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.contact_person || ""
                }}</v-list-item-title>
                <v-text-field
                  v-else
                  v-model="form.contact_person"
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >聯絡電話</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.contact_phone || ""
                }}</v-list-item-title>
                <v-text-field
                  v-else
                  v-model="form.contact_phone"
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >關係</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.contact_relation || ""
                }}</v-list-item-title>
                <v-text-field
                  v-else
                  v-model="form.contact_relation"
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >性別</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.gender || ""
                }}</v-list-item-title>
                <v-select
                  v-else
                  v-model="form.gender"
                  :items="genderOptions"
                  dense
                  hide-details="auto"
                ></v-select>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >生日</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.birthday || ""
                }}</v-list-item-title>
                <v-menu
                  v-else
                  v-model="birthdayMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.birthday"
                      v-bind="attrs"
                      v-on="on"
                      dense
                      hide-details="auto"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="blue"
                    v-model="form.birthday"
                    @input="birthdayMenu = false"
                    locale="zh-TW"
                  ></v-date-picker>
                </v-menu>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >婚姻狀況</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.marital_status || ""
                }}</v-list-item-title>
                <v-select
                  v-else
                  v-model="form.marital_status"
                  :items="maritalStatusOptions"
                  dense
                  hide-details="auto"
                ></v-select>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >兵役狀況</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.military_status || ""
                }}</v-list-item-title>
                <v-select
                  v-else
                  v-model="form.military_status"
                  :items="militaryStatusOptions"
                  dense
                  hide-details="auto"
                ></v-select>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >國籍</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.nationality || ""
                }}</v-list-item-title>
                <v-text-field
                  v-else
                  v-model="form.nationality"
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >最高學歷</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.highest_education || ""
                }}</v-list-item-title>
                <v-select
                  v-else
                  v-model="form.highest_education"
                  :items="highestEducationOptions"
                  dense
                  hide-details="auto"
                ></v-select>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >住家電話</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.home_phone || ""
                }}</v-list-item-title>
                <v-text-field
                  v-else
                  v-model="form.home_phone"
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >戶籍地址</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.registered_address || ""
                }}</v-list-item-title>
                <v-text-field
                  v-else
                  v-model="form.registered_address"
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >通訊地址</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.mailing_address || ""
                }}</v-list-item-title>
                <v-text-field
                  v-else
                  v-model="form.mailing_address"
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { APPROVAL_STATUS, DEFAULT_PASSWORD } from "@/constants";
export default {
  name: "BasicInfoWidget",
  props: {
    userData: {
      type: Object,
      default: () => ({}),
    },
    profileData: {
      type: Object,
      default: () => ({}),
    },
    isCreateMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      edit: this.isCreateMode,
      saving: false,
      DEFAULT_PASSWORD,
      birthdayMenu: false,
      isInitialized: false,
      genderOptions: ["", "男", "女"],
      maritalStatusOptions: ["", "未婚", "已婚", "其他"],
      militaryStatusOptions: ["", "免役", "役畢", "役男", "其他"],
      ROLE_MAPPING: [
        {
          value: "superadmin",
          text: "管理員",
        },
        {
          value: "consultant",
          text: "顧問",
        },
        {
          value: "hr",
          text: "雇主/人資",
        },
        {
          value: "manager",
          text: "主管",
        },
        {
          value: "employee",
          text: "員工",
        },
      ],
      EDITABLE_ROLE_MAPPING: [
        {
          value: "hr",
          text: "雇主/人資",
        },
        {
          value: "manager",
          text: "主管",
        },
        {
          value: "employee",
          text: "員工",
        },
      ],
      highestEducationOptions: [
        "",
        "小學",
        "國中",
        "高中職",
        "專科",
        "大學",
        "碩士",
        "博士",
      ],
      APPROVAL_STATUS_OPTIONS: Object.keys(APPROVAL_STATUS).map((key) => ({
        text: APPROVAL_STATUS[key],
        value: APPROVAL_STATUS[key],
      })),
      form: {
        name: "",
        english_name: "",
        member_id: "",
        user_email: "",
        mobile_country_code: "+886",
        user_mobile_phone: "",
        user_company: "",
        department: "",
        store: "",
        job_title: "",
        user_role: "",
        contact_person: "",
        contact_phone: "",
        contact_relation: "",
        gender: "",
        birthday: "",
        marital_status: "",
        military_status: "",
        nationality: "",
        highest_education: "",
        passport_no: "",
        home_phone: "",
        registered_city: "",
        registered_region: "",
        registered_address: "",
        mailing_city: "",
        mailing_region: "",
        mailing_address: "",
        approval_status: "",
        password: DEFAULT_PASSWORD,
      },
    };
  },
  computed: {
    ...mapGetters({
      userRole: "user/userRole",
      canEditRole: "user/canEditRole",
    }),
    roleText() {
      const role = (this.userData && this.userData.role) || "";
      if (this.ROLE_MAPPING && role) {
        const found = this.ROLE_MAPPING.find((r) => r.value === role);
        if (found) return found.text;
      }
      return role || "";
    },
    approvalStatusText() {
      return this.profileData.approval_status || "";
    },
  },
  watch: {
    profileData: {
      handler() {
        this.resetForm();
      },
      immediate: true,
      deep: true,
    },
    form: {
      handler(newVal) {
        // In create mode, emit changes immediately (but skip initial load)
        if (this.isCreateMode && this.isInitialized) {
          this.$emit("save", newVal, () => {});
        }
      },
      deep: true,
    },
  },
  methods: {
    resetForm() {
      const u = this.userData || {};
      this.form = {
        name: u.name || this.profileData.name || "",
        english_name: u.english_name || this.profileData.english_name || "",
        user_email: u.email || this.profileData.user_email || "",
        mobile_country_code:
          u.mobile_country_code ||
          this.profileData.mobile_country_code ||
          "+886",
        user_mobile_phone:
          u.mobile_phone || this.profileData.user_mobile_phone || "",
        role: u.role || this.profileData.user_role || "",
        member_id: this.profileData.member_id || u.member_id || "",
        user_company: u.company || this.profileData.user_company || "",
        department: this.profileData.department || u.department || "",
        store: this.profileData.store || u.store || "",
        job_title: this.profileData.job_title || u.job_title || "",
        user_role: u.role || this.profileData.user_role || "",
        contact_person: this.profileData.contact_person || "",
        contact_phone: this.profileData.contact_phone || "",
        contact_relation: this.profileData.contact_relation || "",
        gender: this.profileData.gender || "",
        birthday: this.profileData.birthday || "",
        marital_status: this.profileData.marital_status || "",
        military_status: this.profileData.military_status || "",
        nationality: this.profileData.nationality || "",
        highest_education: this.profileData.highest_education || "",
        passport_no: this.profileData.passport_no || "",
        home_phone: this.profileData.home_phone || "",
        registered_city: this.profileData.registered_city || "",
        registered_region: this.profileData.registered_region || "",
        registered_address: this.profileData.registered_address || "",
        mailing_city: this.profileData.mailing_city || "",
        mailing_region: this.profileData.mailing_region || "",
        mailing_address: this.profileData.mailing_address || "",
        approval_status:
          this.userData.approval_status ||
          this.profileData.approval_status ||
          "",
        password: this.isCreateMode
          ? this.userData.password ||
            this.profileData.password ||
            this.DEFAULT_PASSWORD
          : "",
      };
      // Mark as initialized after first reset
      this.$nextTick(() => {
        this.isInitialized = true;
      });
    },
    startEdit() {
      this.edit = true;
      this.resetForm();
    },
    cancelEdit() {
      this.edit = false;
      this.resetForm();
    },
    submit() {
      if (this.saving) return;
      this.saving = true;
      const payload = {
        name: this.form.name,
        department: this.form.department,
        store: this.form.store,
        job_title: this.form.job_title,
        member_id: this.form.member_id,
        email: this.form.user_email,
        mobile_country_code: this.form.mobile_country_code,
        mobile_phone: this.form.user_mobile_phone,
        role: this.form.user_role,
        approval_status: this.form.approval_status,
        password: this.form.password,
        profile: {
          member_id: this.form.member_id,
          contact_person: this.form.contact_person,
          contact_phone: this.form.contact_phone,
          contact_relation: this.form.contact_relation,
          gender: this.form.gender,
          birthday: this.form.birthday,
          marital_status: this.form.marital_status,
          military_status: this.form.military_status,
          nationality: this.form.nationality,
          highest_education: this.form.highest_education,
          passport_no: this.form.passport_no,
          home_phone: this.form.home_phone,
          registered_city: this.form.registered_city,
          registered_region: this.form.registered_region,
          registered_address: this.form.registered_address,
          mailing_city: this.form.mailing_city,
          mailing_region: this.form.mailing_region,
          mailing_address: this.form.mailing_address,
          english_name: this.form.english_name,
        },
      };
      this.$emit("save", payload, (ok) => {
        this.saving = false;
        if (ok) this.edit = false;
      });
    },
    showHistory() {
      this.$emit("show-history");
    },
  },
};
</script>
